"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegTt = void 0;
const base_1 = require("./base");
const tt_1 = require("../services/tt");
/**
 * TikTok
 */
class AnIntegTt extends base_1.AnIntegBase {
    static isLoaded() {
        return tt_1.AnServTt.isLoaded();
    }
    static sendPage(siteCategory, userId, email) {
        tt_1.AnServTt.sendPage(this.getPixelId(siteCategory), null);
        return true;
    }
    static sendTrackClubCheckoutStart(siteCategory) {
        tt_1.AnServTt.sendEventAddToCart(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        tt_1.AnServTt.sendEventAddToCart(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        tt_1.AnServTt.sendEventRegistration(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        tt_1.AnServTt.sendEventRegistration(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubAddPaymentInfo(siteCategory) {
        tt_1.AnServTt.sendEventStartCheckout(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubAddPaymentInfoLegacy(siteCategory) {
        tt_1.AnServTt.sendEventStartCheckout(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        tt_1.AnServTt.sendEventPurchase(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        tt_1.AnServTt.sendEventPurchase(this.getPixelId(siteCategory));
        return true;
    }
}
exports.AnIntegTt = AnIntegTt;
AnIntegTt.shouldSendEveryPage = true;
AnIntegTt.shouldSendTrackClubCheckoutStart = true;
AnIntegTt.shouldSendTrackArriveSignupLoginLegacy = true;
AnIntegTt.shouldSendTrackClubAccountCreate = true;
AnIntegTt.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegTt.shouldSendTrackClubAddPaymentInfo = true;
AnIntegTt.shouldSendTrackClubAddPaymentInfoLegacy = true;
AnIntegTt.shouldSendTrackClubThankyou = true;
AnIntegTt.shouldSendTrackClubThankyouLegacy = true;
AnIntegTt.pixelId = {
    prod: {
        defaultId: TIKTOK_PIXELID,
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: TIKTOK_PIXELID,
        ecomm: null,
        club: null,
    },
};
